'use client'
import { Tabs, Tab } from "@heroui/react";
import TreatmentDetailCard from "./TreatmentDetailCard";
import { useGetAllTreatmeantPhasesApiQuery } from "@/redux/rtkQueries/clientSideGetApis";

const TreatmentTabIndex = ({ slug }: { slug: string }) => {

    const { data: phasesApiResp, isLoading, error } = useGetAllTreatmeantPhasesApiQuery({ slug });
    const phasesData = phasesApiResp?.data || [];

    const formatTreatmentType = (type: string): string => {
        if (!type) return '';
        return type
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' - ');
    };

    const tabItems = phasesData
        ?.filter((curr) => curr?.phases && curr.phases.length > 0)
        ?.map((curr) => {
            // Filter active phases and sort by order
            const activePhases = curr?.phases
                ?.filter((phase) => phase.isActive)
                ?.sort((a, b) => a.order - b.order)
                ?.map((phase) => ({
                    image_url: phase?.image?.url || '',
                    heading: phase?.title || '',
                    description: phase?.description || '',
                    listItems: Array.isArray(phase?.listItems) ? [...phase.listItems] : []
                })) || [];

            return {
                key: curr?.treatmentType || '',
                title: formatTreatmentType(curr?.treatmentType || ''),
                content: activePhases,
            };
        })
        ?.filter((item) => item.content.length > 0) || [];

    // Show loading state
    if (isLoading) {
        return (
            <div className="space_from_side" id="procedure_section">
                <div className="space-y-5">
                    <div className="h-8 bg-gray-200 rounded w-64 animate-pulse"></div>
                    <div className="h-64 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
        );
    }

    // Show error state
    if (error || !tabItems.length) {
        return (
            <div className="space_from_side" id="procedure_section">
                <div className="text-center text-textf2">
                    <p>Unable to load treatment phases. Please try again later.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="space_from_side" id="procedure_section">
            <Tabs
                key="light"
                aria-label="Tabs variants"
                variant="light"
                className="hero_tabs_parent"
                classNames={{
                    tab: "hero_single_tab",
                    tabContent: "hero_tab_content",
                    cursor: "hero_tab_cursor",
                }}
                items={tabItems}
            >
                {(item) => (
                    <Tab key={item.key} title={item.title}>
                        <div className="pt-7.5 space-y-7.5">
                            {item.content.map((phase, index) => (
                                <TreatmentDetailCard
                                    key={index}
                                    image_url={phase.image_url}
                                    heading={phase.heading}
                                    description={phase.description}
                                    listItems={phase.listItems}
                                />
                            ))}
                        </div>
                    </Tab>
                )}
            </Tabs>

        </div>
    )
}

export default TreatmentTabIndex